import React from "react"
import { Heading1 } from "../../styles/Heading"
import { StyledHeader } from "../../styles/Header"

import styled from "@emotion/styled"
import { UIModel, UIAction } from "../../store/ui"
const logo = require("../../logoWithText.svg")

interface Props {
  uiState: UIModel
  uiDispatch: React.Dispatch<UIAction>
}

export default function Header({ uiState, uiDispatch }: Props) {
  const language = uiState.language

  return (
    <StyledHeader>
      <LogoImg src={logo} alt="Statens vegvesen" />
      <Heading1 style={{ color: "white" }}>Veglister</Heading1>
      <LanguageButtonContainer>
        <LanguageButton
          className={language === "nb_NO" ? `selected` : ``}
          onClick={() => uiDispatch({ type: "SetLanguage", payload: "nb_NO" })}
        >
          Bokmål
        </LanguageButton>
        <span style={{ color: "lightgray" }}>|</span>
        <LanguageButton
          className={language === "nn_NO" ? `selected` : ``}
          onClick={() => uiDispatch({ type: "SetLanguage", payload: "nn_NO" })}
        >
          Nynorsk
        </LanguageButton>
      </LanguageButtonContainer>
    </StyledHeader>
  )
}

const LanguageButtonContainer = styled.aside`
  width: 200px;
`

const LanguageButton = styled.button`
  border: none;
  background-color: transparent;
  text-decoration: none;
  font-size: 1rem;
  margin: 0 0.5rem;
  color: lightgray;
  cursor: pointer;

  &:hover {
    color: white;
  }

  &.selected {
    color: white;
    text-decoration: underline;
  }
`

const LogoImg = styled.img`
  width: 150px;
`
